import { useQuery } from "react-query";
import Cookies from "js-cookie";
import { serverBaseUrl } from "../config/envs";

const getTasks = async (queryParams) => {
  const { page = 1, limit = 10, token = null, ...filters } = queryParams;

  let headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const url = new URL(`${serverBaseUrl}/get_templates`);
  url.searchParams.append("page", String(page));
  url.searchParams.append("limit", String(limit));

  for (const key in filters) {
    if (filters[key]) {
      url.searchParams.append(key, filters[key]);
    }
  }

  try {
    const response = await fetch(url.toString(), { headers });

    if (!response.ok) {
      let errorData = {
        status: response?.status,
        message: response?.statusText,
      };

      try {
        const json = await response.json();
        errorData.message = json.message || errorData.message;
        errorData.messageCode = json.messageCode;
        errorData.data = json.data;
        errorData.success = json.success;
      } catch (jsonError) {
        console.error("Failed to parse JSON error response:", jsonError);
      }

      throw new Error(JSON.stringify(errorData));
    }

    return response.json();
  } catch (error) {
    console.log(error, "from catch");
    throw error;
  }
};

export const useGetAllTemplateQuery = (queryParams) => {
  const token = Cookies.get("token");
  const allParams = { ...queryParams, token };

  return useQuery(["get_templates", allParams], () => getTasks(allParams), {
    retry: false,
    keepPreviousData: true,
  });
};
